export default __webpack_public_path__ + "static/media/pm2.b8eda36a.svg";